import { defineStore } from 'pinia';
import { axios } from '@boot/axios.js';
/**
 * Return the default state for the quality events store.
 */
function getDefaultState() {
    return {
        qualityEvents: {}
    };
}
/**
 * Store for managing quality event data.
 */
export const useQualityEventsStore = defineStore('qualityEvents', {
    state: () => getDefaultState(),
    getters: {
        /**
         * Get quality event for an asset by asset id.
         */
        getQualityEvent: state => {
            return (assetId) => {
                const id = Number(assetId);
                if (state.qualityEvents[id]) {
                    return state.qualityEvents[id];
                }
                else {
                    return null;
                }
            };
        }
    },
    actions: {
        /**
         * Reset store state.
         */
        resetState() {
            this.$reset();
        },
        /**
         * Action to set a quality event.
         */
        setQualityEventAction(notification) {
            const newEvent = {
                eventID: notification.eventID,
                eventUUID: notification.eventUUID,
                assetID: notification.assetID,
                eventDefectID: notification.eventDefectID,
                start: notification.start,
                end: notification.end || null,
                productID: notification.productID,
                grossProductCount: notification.grossProductCount,
                rejectedProductCount: notification.rejectedProductCount
            };
            this.qualityEvents[newEvent.assetID] = newEvent;
        },
        /**
         * Load quality events for a specific asset.
         */
        async loadQualityEventAction(assetID) {
            try {
                const response = await axios.get(`quality_events/current/?asset=${assetID}`);
                const qualityEvents = response.data.results;
                const id = Number(assetID);
                // if the quality event is ongoing, set the ongoing quality event in the store
                if (qualityEvents.length > 0) {
                    // ideally, there should only be one ongoing quality event
                    // In case there are multiple, we only consider the first one
                    const currentQualityEvent = {
                        eventID: qualityEvents[0]['id'],
                        eventUUID: qualityEvents[0]['uuid'],
                        assetID: qualityEvents[0]['asset'],
                        eventDefectID: qualityEvents[0]['defect'],
                        start: qualityEvents[0]['start'],
                        end: qualityEvents[0]['end'],
                        productID: qualityEvents[0]['product'],
                        grossProductCount: qualityEvents[0]['gross_production'],
                        rejectedProductCount: qualityEvents[0]['rejected_production']
                    };
                    // The API was supposed to return quality events filtered by asset ID,
                    // but to be safe, we use the assetID from the returned quality event
                    this.qualityEvents[currentQualityEvent.assetID] =
                        currentQualityEvent;
                }
                else {
                    // if there are no ongoing quality events,
                    // remove the current quality event from the store
                    delete this.qualityEvents[id];
                }
            }
            catch (error) {
                console.error('Failed to load quality events due to: ', error);
                throw error;
            }
        },
        /**
         * Removes the current quality event.
         */
        removeQualityEventAction(assetID) {
            const id = Number(assetID);
            delete this.qualityEvents[id];
        }
    }
});
